<template lang="pug">
  .content
    .md-layout.md-gutter.md-alignment-center-center
      .md-layout-item.md-size-40.md-medium-size-55.md-xsmall-size-100
        form(@submit.prevent="")
          md-card
            md-card-header(data-background-color='green')
              h4.title Reset Password
              p.category Enter your new password information.
            md-card-content(v-if="success")
              .md-layout
                .text-center.md-layout-item
                  h4 Your password was succesfully reset!
                  br
                  router-link(:to='{name: "Signin"}') Log in now.
            md-card-content(v-else)
              .md-layout
                .md-layout-item.md-size-100
                  md-field
                    label New Password
                    md-input(v-model='password1', type='password' required)
                .md-layout-item.md-size-100
                  md-field
                    label Confirm Password
                    md-input(v-model='password2', type='password' required)
                .md-layout-item.md-size-100.text-right
                  h6(v-if="resetError" style="color: red") Sorry, there was an error resetting your password, please try again.
                  h6(v-if="passwordError" style="color: red") Your passwords do not match!
                  md-button.md-raised.md-success(type="submit" v-on:click="resetPassword") Reset Password
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      password1: null,
      password2: null,
      resetError: null,
      passwordError: null,
      success: null,
    };
  },
  methods: {
    resetPassword() {
      let patchData = {
        password1: this.password1,
        password2: this.password2
      };
      if (this.password1 === this.password2) {
        axios
        .post(`/api/passwordresetconfirm/${this.$route.params.token}`, patchData)
        .then((response) => {
          this.success = true;
          this.$store.commit('logout', 'clear');
        }).catch((error) => {
          this.resetError = true;
        })
      } else {
        this.passwordError = true;
      }

    }
  }
};
</script>

<style scoped>
  form{
    margin-top: 100px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/UserManagement/PasswordReset.vue